import { motion } from "framer-motion";
import { FadeUp } from "./Reveal";

const STAGES = [
  { name: "Leadership", desc: "What leaders make clear and reinforce." },
  { name: "Operational Clarity", desc: "What people understand about the work.", signal: true },
  { name: "Behaviour and judgement", desc: "How people decide, escalate and act." },
  { name: "Execution", desc: "How consistently the work gets done." },
  { name: "Performance", desc: "The operational and business result." },
];

export const PerformanceLogic = ({ dark = true }) => (
  <div data-testid="performance-logic" className="w-full">
    <div className="grid grid-cols-1 md:grid-cols-5 gap-px bg-current/0">
      {STAGES.map((s, i) => (
        <FadeUp key={s.name} delay={i * 0.12} className="relative">
          <div
            data-testid={`logic-stage-${i + 1}`}
            className={`h-full border-t pt-5 pr-4 ${
              dark
                ? s.signal ? "border-terra" : "border-paper/20"
                : s.signal ? "border-terra" : "border-ink/20"
            }`}
          >
            <div className="flex items-center gap-2">
              {i < STAGES.length - 1 && (
                <motion.span
                  className={`hidden md:block h-px flex-1 origin-left ${dark ? "bg-paper/20" : "bg-ink/20"}`}
                  initial={{ scaleX: 0 }}
                  whileInView={{ scaleX: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.3 + i * 0.12 }}
                />
              )}
            </div>
            <h4 className={`mt-3 font-display text-xl tracking-tight ${s.signal ? "text-terra" : ""}`}>{s.name}</h4>
            <p className={`mt-2 text-[13px] leading-relaxed ${dark ? "text-paper/55" : "text-mute"}`}>{s.desc}</p>
          </div>
        </FadeUp>
      ))}
    </div>
    <FadeUp delay={0.5} className="mt-10">
      <p className={`max-w-2xl text-sm leading-relaxed ${dark ? "text-paper/60" : "text-mute"}`}>
        Leadership makes the work clear. That clarity shapes behaviour and judgement. Repeated
        behaviour becomes execution, and execution produces performance.
      </p>
    </FadeUp>
  </div>
);
